import React, { useState } from "react";
import { TextField, Grid, Paper, Button, Backdrop, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';

function ChangePasswordForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordRepetition, setNewPasswordRepetition] = useState('');

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset'
            }, "& .MuiSvgIcon-root": {
                position: 'inherit'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0"
    };
    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newPassword === newPasswordRepetition) {
            setOpen(true);
            axios.get('/api/v1/Profile/ChangePasswordGET', {
                params: {
                    customerId: getAuthenticationToken().userID,
                    currentPassword: oldPassword,
                    goingToChangePassword: newPassword
                }
            }).then(response => {
                setMessageNotify({
                    severity: "success",
                    message: "تغییر پسورد با موفقیت انجام شد",
                    open: true
                });
            }).catch((e) => {
                setMessageNotify({
                    severity: "error",
                    message: "(در ورود پسورد قدیمی دقت کنید)خطا در تغییر پسورد",
                    open: true
                });
            }).finally(() => {
                setOpen(false);
            })
        }
        else {
            setMessageNotify({
                severity: "warning",
                message: "پسورد جدید وارد شده با تکرار آن برابر نیست",
                open: true
            });

        }
    }

    const resetPassword = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.get('/api/v1/Profile/SetDefaultCustomerPassword', {
            params: {
                customerId: getAuthenticationToken().userID
            }
        }).then(response => {
            setMessageNotify({
                severity: "success",
                message: "تغییر پسورد به پسورد پیش فرض با موفقیت انجام شد",
                open: true
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در تغییر پسورد",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        })
    }

    return (<>
        <form onSubmit={handleSubmit}>
            <Paper elevation={10} style={paperStyle} >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="oldPassword"
                            name="oldPassword"
                            label="پسورد قدیمی"
                            fullWidth
                            type="password"
                            variant="standard"
                            value={oldPassword}
                            onChange={e=>setOldPassword(e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField style={{ display: 'none' }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="newPassword"
                            name="newPassword"
                            label="پسورد جدید"
                            fullWidth
                            type="password"
                            variant="standard"
                            value={newPassword}
                            onChange={e=>setNewPassword(e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            style={formElementStyle}
                            className={classes.root}
                            id="newPasswordRepetition"
                            name="newPasswordRepetition"
                            label="تکرار پسورد جدید"
                            fullWidth
                            type="password"
                            variant="standard"
                            value={newPasswordRepetition}
                            onChange={e=>setNewPasswordRepetition(e.target.value)} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button
                            id="submit"
                            type='submit'
                            name="submit"
                            fullWidth
                            variant="contained"
                            color="success" >ثبت پسورد جدید</Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button
                            onClick={() => { props.history.push('/') }}
                            id="cancel"
                            name="cancel"
                            fullWidth
                            variant="outlined"
                            color="error" >انصراف</Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Button
                            onClick={resetPassword}
                            id="resetPassword"
                            name="resetPassword"
                            fullWidth
                            variant="contained"
                            color="warning" >تغییر پسورد به پسورد پیش فرض</Button>
                    </Grid>
                </Grid>
            </Paper>
        </form>
        <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </>
    );
}

export default withRouter(ChangePasswordForm);